<template>
  <div id="Lnotice">
    <div class="LnoticeTitle">消息通知</div>
    <div class="LnoticeConter" v-show="flag">
      <div class="LnoticeConterList" v-for="(item, i) in pageList" :key="i">
        <Badge dot :count="item.isRead == 1?1:0">
          <div class="tongh">
            <div @click="tzdetail(item.id)" class="LnoticeListText">{{ item.title }}</div>
            <div class="LnoticeListTime">
              <span>{{ shijiantime(item.createTime) }}</span>
            </div>
          </div>
        </Badge>

      </div>
    </div>
    <div v-show="!flag">
      暂无消息
    </div>
    <!-- 分页 -->
    <div style="display:flex;justify-content: flex-end;margin-top:20px">
        <Page :total="total" show-total :current="curPage" :page-size="maxPage" @on-change="onChange"  />
    </div>
    <!-- <div class="LnoticeFoot">
      <Page
        :total="total"
        show-total
        show-sizer
        @on-page-size-change="sizeChange"
        @on-change="pageChange"
      />
    </div> -->
  </div>
</template>

<script>
import {selectCustomerNoticePage, selectCustomerNoticeById} from "../../../network/LPersonal";

export default {
  data() {
    return {
      total: 1000,
      flag: true,
      pageList: [],
      historyData: [],
      current: 1,
      boQuery: false,
      ajaxHistoryData: [],
      // 初始化信息总条数
      dataCount: 0,
      // 每页显示多少条
      pageSize: 10,
      //总共多少页
      totalTs: 1,
      curPage:1,
      maxPage: 10,
      form: {
        curPage: 1,
        maxPage: 10,
        type: 0,
      },
    };
  },
  created() {
    this.get();
    this.$emit("editPage", "消息中心", "消息中心");
  },
  activated() {
    this.$emit("editPage", "消息中心", "消息中心");
  },
  methods: {
    // 分页器
    onChange(value){
        this.curPage = value
        this.get()
    },
    // 通知管理的接口  后台还没有   后期自行更换正确接口
    get() {
      selectCustomerNoticePage({
        curPage: this.current,
        maxPage: this.pageSize
      }).then((res) => {
        console.log(res)
        let arr = res.data.data.data;
        this.pageList = arr;
        this.total = res.data.data.total;
        if (this.pageList.length) {
          this.flag = true
        } else {
          this.flag = false
        }
      });
    },
    //分页器
    handleListApproveHistory() {
      // 保存取到的所有数据
      this.ajaxHistoryData = this.list;
      // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
      if (this.list.length < this.pageSize) {
        this.historyData = this.ajaxHistoryData;
      } else {
        this.historyData = this.ajaxHistoryData.slice(0, this.pageSize);
      }
    },
    changepage(index) {
      this.current = index;
      var _start = (index - 1) * this.pageSize;
      var _end = index * this.pageSize;
      this.historyData = this.ajaxHistoryData.slice(_start, _end);
      if (this.boQuery) {
        this.handleSubmit();
      } else {
        this.getData();
      }
    },
    changepagesize(pageSize) {
      this.pageSize = pageSize;
      if (this.boQuery) {
        this.handleSubmit();
      } else {
        this.getData();
      }
      this.handleListApproveHistory()
    },
    // 页数
    pageChange(page) {
      console.log("页数发生变化", page);
      this.form.curPage = page;
      this.get();
    },
    // 条数变化
    sizeChange(size) {
      console.log("条数发生变化", size);
      this.form.maxPage = size;
      this.get();
    },
    shijiantime(times) {
      var newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(times);
      return newDate[0];
    },
    tzdetail(id) {
      this.$router.push({
        path:"/noticeDetail",
        query:{
          id,
          type: 1
        }
      });
    },
  },
};
</script>

<style>
@import url("../../../assets/css/liucss/notice.css");
</style>